import { InteracTransactionResponse } from 'vopay';
import { useEffect, FC, useState } from 'react';
import InteracMoneyRequestTransactionInfo from './InteracMoneyRequestTransactionInfo';
import useFetchInteracMoneyRequestTransaction from '@/hooks/useApi/useFetchInteracMoneyRequestTransaction';

type TransactionProps = {
  TransactionID: string;
  Notes?: string;
  isParent?: boolean;
};

const InteracMoneyRequestTransactionContainer: FC<TransactionProps> = ({ TransactionID, Notes, isParent = false }) => {
  const [InteracMoneyRequest, getInteracMoneyRequestTransaction] = useFetchInteracMoneyRequestTransaction({
    bearer: '',
  });
  const [currentTransactionId, setCurrentTransactionId] = useState<string>();
  const [transaction, setTransaction] = useState<InteracTransactionResponse>();

  useEffect(() => {
    getInteracMoneyRequestTransaction(TransactionID);
  }, [currentTransactionId]);

  useEffect(() => {
    if (InteracMoneyRequest) {
      setTransaction(InteracMoneyRequest);
    }
  }, [InteracMoneyRequest]);

  if (currentTransactionId !== TransactionID) {
    setCurrentTransactionId(TransactionID);
  }

  return (
    <div>
      {transaction && (
        <InteracMoneyRequestTransactionInfo transaction={transaction} Notes={Notes || ''} isParent={isParent} />
      )}
    </div>
  );
};

export default InteracMoneyRequestTransactionContainer;
